import { HighlightSectionSkeletonContent } from './components/highlight-section-skeleton-content';

export const EventReportHighlightSectionSkeleton = ({ title, subtitle }: { title: string; subtitle?: string }) => {
  return (
    <section className='mb-14 md:mb-20'>
      <HighlightSectionSkeletonContent title={title} subtitle={subtitle} />
    </section>
  );
};
